module.exports = __webpack_public_path__ + "static/media/drum-min.3c67808a.jpg";